export const SET_BASE_PAYMENT_METHODS =
  "paymentMethods/SET_BASE_PAYMENT_METHODS";
